import { render, staticRenderFns } from "./BatchPolicyRelease.vue?vue&type=template&id=68ab44f4&"
import script from "./BatchPolicyRelease.vue?vue&type=script&lang=js&"
export * from "./BatchPolicyRelease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports